import { useState, useCallback } from "react";

export default function usePlannerSelection() {
  const [selectedShiftId, setSelectedShiftId] = useState("");
  const [selectedShiftIds, setSelectedShiftIds] = useState([]);

  const toggleShiftSelection = useCallback((shiftId) => {
    if (!shiftId) return;

    setSelectedShiftIds((prev) =>
      prev.includes(shiftId)
        ? prev.filter((id) => id !== shiftId)
        : [...prev, shiftId]
    );
  }, []);

  const clearShiftSelection = useCallback(() => {
    setSelectedShiftIds([]);
  }, []);

  const clearSelectedShift = useCallback(() => {
    setSelectedShiftId("");
  }, []);

  return {
    selectedShiftId,
    setSelectedShiftId,
    selectedShiftIds,
    setSelectedShiftIds,
    toggleShiftSelection,
    clearShiftSelection,
    clearSelectedShift,
  };
}